import { render, staticRenderFns } from "./large-post.vue?vue&type=template&id=6a49836b&"
import script from "./large-post.vue?vue&type=script&lang=js&"
export * from "./large-post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports